var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _a;
import { IdAssetBundleCore } from "../features/loading/IdAssetBundleCore";
import { assetBundleBuildings } from "./assetBundleBuildings";
import { assetBundleBuildingsInitial } from "./assetBundleBuildingsInitial";
import { assetBundleCalloutIcons } from "./assetBundleCalloutIcons";
import { assetBundleFence } from "./assetBundleFence";
import { assetBundleGrounds } from "./assetBundleGrounds";
import { assetBundleProductionAnims } from "./assetBundleProductionAnims";
import { assetBundleBalancingInitial } from "./balancing/assetBundleBalancingInitial";
import { assetBundleBalloon } from "./static/assetBundleBalloon";
import { assetBundleInitialStatic } from "./static/assetBundleInitialStatic";
export var assetBundles = (_a = {},
    _a[IdAssetBundleCore.Initial] = __assign({}, assetBundleBalancingInitial, assetBundleInitialStatic, assetBundleBuildingsInitial, assetBundleGrounds, assetBundleBalloon),
    _a[IdAssetBundleCore.CalloutIcons] = __assign({}, assetBundleCalloutIcons),
    _a[IdAssetBundleCore.Buildings] = __assign({}, assetBundleBuildings),
    _a[IdAssetBundleCore.Animations] = __assign({}, assetBundleProductionAnims),
    _a[IdAssetBundleCore.Outskirts] = {},
    _a[IdAssetBundleCore.Fence] = __assign({}, assetBundleFence),
    _a);



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/assetBundles.ts
// module id = 1712
// module chunks = 3